import { render, staticRenderFns } from "./StudentInfoForm.vue?vue&type=template&id=6beeb33e"
import script from "./StudentInfoForm.vue?vue&type=script&lang=js"
export * from "./StudentInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6beeb33e')) {
      api.createRecord('6beeb33e', component.options)
    } else {
      api.reload('6beeb33e', component.options)
    }
    module.hot.accept("./StudentInfoForm.vue?vue&type=template&id=6beeb33e", function () {
      api.rerender('6beeb33e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentInfo/modules/StudentInfoForm.vue"
export default component.exports